import SuggestionBoard from './suggestion-board.vue';

export default SuggestionBoard;
